import VehicleMaintenanceIndex from "@/views/vehicle-maintenance/VehicleMaintenanceIndex.vue";
import VehicleMaintenanceForm from "@/views/vehicle-maintenance/VehicleMaintenanceForm.vue";
import VehicleMaintenanceDetail from "@/views/vehicle-maintenance/VehicleMaintenanceDetail.vue";

const vehicleMaintenance = [
    {
        path: '/vehicle-maintenance',
        name: 'vehicle-maintenance',
        component: VehicleMaintenanceIndex,
        meta: {
            requiresAuth: true,
            roles: ["Super Admin", "Admin Office", 'Manager Driver'],
        },
    },
    {
        path: '/vehicle-maintenance/add',
        name: 'vehicle-maintenance-add',
        component: VehicleMaintenanceForm,
        meta: {
            requiresAuth: true,
            roles: ["Super Admin", "Admin Office", 'Manager Driver'],
        },
    },
    {
        path: '/vehicle-maintenance/edit/:uuid',
        name: 'vehicle-maintenance-edit',
        component: VehicleMaintenanceForm,
        meta: {
             requiresAuth: true,
            roles: ["Super Admin", "Admin Office", 'Manager Driver'],
        },
    },
    {
        path: '/vehicle-maintenance/detail/:uuid',
        name: 'vehicle-maintenance-detail',
        component: VehicleMaintenanceDetail,
        meta: {
             requiresAuth: true,
            roles: ["Super Admin", "Admin Office", 'Manager Driver'],
        },
    }
];

export default vehicleMaintenance;
